import React from 'react';

export default function AccessGate() {
  return (
    <div style={s.container}>
      <div style={s.header}>
        <img src="/logo.png" alt="Translating Insurance" style={s.logoImg} />
      </div>
      <div style={s.titleBar}>LINK NOT VALID</div>
      <div style={s.card}>
        <h2 style={s.heading}>This Link Is Invalid or Has Expired</h2>
        <p style={s.copy}>
          Please contact your agent for a new invite link.
        </p>
      </div>
    </div>
  );
}

const s = {
  container: {
    width: '100%',
    maxWidth: 620,
    margin: '0 auto',
    paddingTop: 32,
  },
  header: {
    textAlign: 'center',
    marginBottom: 12,
  },
  logoImg: {
    maxWidth: 340,
    width: '100%',
    height: 'auto',
  },
  titleBar: {
    background: '#1a3364',
    borderRadius: 8,
    padding: '13px 24px',
    textAlign: 'center',
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    letterSpacing: '0.08em',
    marginBottom: 24,
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: '28px 32px',
    boxShadow: '0 2px 16px rgba(26,51,100,0.10)',
    textAlign: 'center',
  },
  heading: {
    color: '#1a3364',
    marginTop: 0,
    marginBottom: 10,
  },
  copy: {
    color: '#4a6288',
    lineHeight: 1.6,
    marginTop: 0,
  },
};
